import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import { colors } from '../../styles';

export interface Props {
  activator?: Element;
  children: any;
  className?: string;
  clickable?: boolean;
}

export interface State {
  arrowLocation: string;
  left: string;
  top: string;
}

class ToolTipContent extends React.Component<Props, State> {
  public el;

  constructor(props: Props) {
    super(props);
    this.state = {
      arrowLocation: '',
      left: '0px',
      top: '0px',
    };
  }

  public componentDidMount() {
    window.addEventListener('scroll', this.setTooltipPosition, false);
    this.setTooltipPosition();
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.setTooltipPosition, false);
  }

  public render() {
    const { children, className, clickable } = this.props;
    const { arrowLocation, left, top } = this.state;
    const isText: boolean = typeof children === 'string';

    return (
      <div
        className={`${className} ${arrowLocation} ${
          isText ? 'text' : ''
        } ${!clickable && 'not-clickable'}`}
        ref={el => {
          if (el) {
            this.el = el;
            this.el.style.left = left;
            this.el.style.top = top;
          }
        }}
        style={{ top, left }}
      >
        {children}
      </div>
    );
  }

  private setTooltipPosition = () => {
    const { arrowLocation, left, top } = this.positionToolTip();
    this.setState({
      arrowLocation,
      left,
      top,
    });
  };

  private positionToolTip = (): State => {
    const OUTER_SPACING = 10;
    const activator = this.props.activator.getBoundingClientRect();
    const tooltip = this.el.getBoundingClientRect();
    const body = document.body.getBoundingClientRect();

    const shouldBeAbove = activator.top > tooltip.bottom;

    const activatorHorizontalCenter = Math.floor(
      activator.left + activator.width / 2,
    );

    const tooltipHorizontalCenter = Math.floor(tooltip.width / 2);

    const verticalOffset = shouldBeAbove
      ? activator.top - tooltip.height - OUTER_SPACING
      : activator.bottom + OUTER_SPACING;

    let horizontalOffset = activatorHorizontalCenter - tooltipHorizontalCenter;
    let horizontalArrowLocation = '';

    const shouldBeLeft = horizontalOffset - tooltipHorizontalCenter < body.left;
    const shouldBeRight = horizontalOffset + tooltip.width > body.right;
    const verticalArrowLocation = shouldBeAbove ? 'arrow-bottom' : 'arrow-top';

    if (shouldBeLeft) {
      horizontalOffset = activator.left;
      horizontalArrowLocation = 'arrow-left';
    } else if (shouldBeRight) {
      horizontalOffset = activator.right - tooltip.width;
      horizontalArrowLocation = 'arrow-right';
    }

    return {
      arrowLocation: `${verticalArrowLocation} ${horizontalArrowLocation}`,
      left: `${horizontalOffset}px`,
      top: `${verticalOffset}px`,
    };
  };
}

const arrowSize = 6;

export default styled(ToolTipContent)`
  position: fixed;
  background: ${colors.black};
  border-radius: 4px;
  color: #fff;
  top: 0;
  left: 0;
  min-width: 100px;
  z-index: 12;
  &.text {
    max-width: 300px;
    padding: 1rem;
    text-align: center;
  }

  &.arrow-bottom:after {
    content: ' ';
    width: 0;
    height: 0;
    position: absolute;
    bottom: -${arrowSize}px;
    left: calc(50% - ${arrowSize}px);
    border-left: ${arrowSize}px solid transparent;
    border-right: ${arrowSize}px solid transparent;
    border-top: ${arrowSize}px solid ${colors.black};
  }

  &.arrow-top:after {
    content: ' ';
    width: 0;
    height: 0;
    position: absolute;
    top: -${arrowSize}px;
    left: calc(50% - ${arrowSize}px);
    border-left: ${arrowSize}px solid transparent;
    border-right: ${arrowSize}px solid transparent;
    border-bottom: ${arrowSize}px solid ${colors.black};
  }

  &.arrow-left:after {
    left: 10px;
  }

  &.arrow-right:after {
    left: auto;
    right: 10px;
  }
  .not-clickable {
    pointer-events: none;
  }
`;
